var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash-alt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,10.625 L9,9.75 C9,9.334375 9.334375,9 9.75,9 L13.25,9 L13.54375,8.415625 C13.66875,8.159375 13.928125,8 14.2125,8 L17.784375,8 C18.06875,8 18.328125,8.159375 18.45625,8.415625 L18.75,9 L22.25,9 C22.665625,9 23,9.334375 23,9.75 L23,10.625 C23,10.83125 22.83125,11 22.625,11 L9.375,11 C9.16875,11 9,10.83125 9,10.625 Z M22,12.375 L22,22.5 C22,23.328125 21.328125,24 20.5,24 L11.5,24 C10.671875,24 10,23.328125 10,22.5 L10,12.375 C10,12.16875 10.16875,12 10.375,12 L21.625,12 C21.83125,12 22,12.16875 22,12.375 Z M13.5,14.5 C13.5,14.225 13.275,14 13,14 C12.725,14 12.5,14.225 12.5,14.5 L12.5,21.5 C12.5,21.775 12.725,22 13,22 C13.275,22 13.5,21.775 13.5,21.5 L13.5,14.5 Z M16.5,14.5 C16.5,14.225 16.275,14 16,14 C15.725,14 15.5,14.225 15.5,14.5 L15.5,21.5 C15.5,21.775 15.725,22 16,22 C16.275,22 16.5,21.775 16.5,21.5 L16.5,14.5 Z M19.5,14.5 C19.5,14.225 19.275,14 19,14 C18.725,14 18.5,14.225 18.5,14.5 L18.5,21.5 C18.5,21.775 18.725,22 19,22 C19.275,22 19.5,21.775 19.5,21.5 L19.5,14.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Central-Admin-_-Company-Configration-/-User-Groups",
    transform: "translate(-220.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(123.000000, 368.972324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(88.000000, 0.027676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "trash-alt",
    fill: "var(--tru-danger-color)",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAlt);
export default ForwardRef;